<template lang="html">
    <div>
        Criar Página
        <page-form ref="pageForm" v-model="page" @change="pageFormChange($event)" />

        <!-- Buttons -->
        <v-container>
          <div class="text-xs-right">
            <v-btn color="" large>Cancelar</v-btn>
            <v-btn color="success" :disabled="!isPageValid" large @click="clickCreate()">Guardar</v-btn>
          </div>
        </v-container>

    </div>
</template>

<script>
import { mapActions } from 'vuex'
import pageForm from '@/components/Page/pageForm'
export default {
  data: function () {
    return {
      isPageValid: false,
      page: {
        title: null,
        urlSlug: null,
        body: null
      }
    }
  },
  methods: {
    ...mapActions([
      'createPage'
    ]),
    clickCreate: function () {
      this.createPage(this.page).then(() => {
        this.$router.push({ name: 'PageList' })
      })
    },
    pageFormChange: function ($event) {
      this.isPageValid = $event.valid
    }
  },
  components:{
    pageForm
  }
}
</script>

<style lang="css" scoped>
</style>
